import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export const fncPopulatePricelistList = ({ commit, dispatch, state, rootState }, payload) => {
    if (state.pricelistList.length == 0 || (payload != undefined && payload.refresh == true)) {
        var objAuth = JSON.parse(rootState.objAuthorize);
        Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
            .then(response => {
                return response.json();
            }, error => {
                var snackDetails = { color: 'error', message: 'An error has occured', display: true };
                commit('setSnack', snackDetails);
                console.log(error);
            }).then(data => {
            var tokenDetails = { token: data.token, manufacturer_id: objAuth.manufacturer, is_library_pricelist: 0 };
            Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
                .then(response => {
                    return response.json();
                }, error => {
                    var snackDetails = { color: 'error', message: 'An error has occured', display: true };
                    commit('setSnack', snackDetails);
                    console.log(error);
                }).then(dt => {
                commit('setPricelistList', dt);
            });
        });
    }
}

export const fncDeletePricelist = ({commit, dispatch, state, rootState}, payload) => {
    var objAuth = JSON.parse(rootState.objAuthorize);
    Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
        .then(response => {
            return response.json();
        }, error => {
            var snackDetails = {color: 'error', message: 'An error has occured', display: true};
            commit('setSnack', snackDetails);
            console.log(error);
        }).then(data => {
        var dataToken = data.token;
        var pricelistDetails = {token: dataToken, locked_status: '1', pricelist_id: payload.pricelistId, locked_by_id: objAuth.id};
        Vue.http.post(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/lock_pricelist', pricelistDetails, rootState.headerDetails)
            .then(response => {
                return response.json();
            }, error => {
                var snackDetails = {color: 'error', message: 'An error has occured while trying to remove the price list', display: true};
                commit('setSnack', snackDetails);
            }).then(dt => {
            if( dt.success === true ) {
                var deleteParams = { token: dataToken, pricelist_id: payload.pricelistId, deleted: 1, modified_by: objAuth.id };
                Vue.http.post(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', deleteParams, rootState.headerDetails)
                    .then(response => {
                        return response.json();
                    }, error => {
                        var snackDetails = {color: 'error', message: 'An error has occured while trying to remove the price list', display: true};
                        commit('setSnack', snackDetails);
                    }).then(d => {
                    var plistDetails = { plist: d[0].pl_id };
                    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=remove_user_link', plistDetails, rootState.headerDetails)
                        .then(response => {
                            return response.json();
                        }, error => {
                            var snackDetails = { color: 'error', message: 'An error has occured while trying to clone the pricelist', display: true };
                            commit('setSnack', snackDetails);
                            console.log(error);
                        }).then(p => {
                        var snackDetails = { color: 'success', message: 'The pricelist has been removed successfully', display: true };
                        commit('setSnack', snackDetails);
                        dispatch({
                            type: 'fncPopulatePricelistList',
                            refresh: true
                        })
                    });
                });
            } else {
                var snackDetails = {color: 'error', message: 'An error has occured while trying to remove the price list', display: true};
                commit('setSnack', snackDetails);
            }

        });
    });
}

export const fncPopulatePricingTable = ({ commit, dispatch, state, rootState }, payload) => {
    if ((state.priceTableDetails == '' || state.priceTableDetails == undefined) || (payload != undefined && (payload.reload == true || payload.refresh == true))) {
        var objAuth = JSON.parse(rootState.objAuthorize);
        Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
            .then(response => {
                return response.json();
            }, error => {
                var snackDetails = { color: 'error', message: 'An error has occured', display: true };
                commit('setSnack', snackDetails);
                console.log(error);
            }).then(data => {
            var tokenDetails = { token: data.token, manufacturer_id: objAuth.manufacturer, 'is_library_pricelist': 1 };
            Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
                .then(response => {
                    return response.json();
                }, error => {
                    var snackDetails = { color: 'error', message: 'An error has occured', display: true };
                    commit('setSnack', snackDetails);
                    console.log(error);
                }).then(dt => {
                var priceList = dt[0];
                var listDetails = { token: data.token, list_id: priceList.pl_id }
                Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelist_items', { params: listDetails }, rootState.headerDetails)
                    .then(response => {
                        return response.json();
                    }, error => {
                        var snackDetails = { color: 'error', message: 'An error has occured', display: true };
                        commit('setSnack', snackDetails);
                    }).then(d => {
                        // commit('setPriceTable', d);
                        if (payload != undefined && payload.reload == true) {
                            var snackDetails = { color: 'success', message: 'Pricelist reload successfull', display: true };
                            commit('setSnack', snackDetails);
                        }
                });
            });
        });
    }
}

export const fncAddPlist = ({commit, dispatch, state, rootState}, payload) => {
    commit('setRunAdd', true);
    var objAuth = JSON.parse(rootState.objAuthorize);
    Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
        .then(response => {
            return response.json();
        }, error => {
            var snackDetails = {color: 'error', message: 'An error has occured while trying to add the pricelist', display: true};
            commit('setSnack', snackDetails);
            console.log(error);
        }).then(data => {
        var dataToken = data.token;
        var tokenDetails = {token: data.token, manufacturer_id: objAuth.manufacturer, 'default': 1};
        var plistDetails = {
            token: data.token,
            pricelist_name: payload.params.pricelistName,
            pricelist_description: payload.params.pricelistDescription,
            default: payload.params.pricelistDefault,
            cost: payload.params.pricelistCostPricelist,
            active: payload.params.pricelistActive,
            manufacturer_id: objAuth.manufacturer,
            created_by_id: objAuth.id,
            tax_label: payload.params.pricelistTaxLabel,
            tax_percentage: payload.params.pricelistTaxRate,
            currency_sym: payload.params.pricelistCurrencySymbol,
            currency_code: payload.params.pricelistCurrencyCode
        }
        Vue.http.post(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/create_pricelist', plistDetails, rootState.headerDetails)
            .then(response => {
                return response.json();
            }, error => {
                var snackDetails = {color: 'error', message: 'An error has occured while trying to add the pricelist', display: true};
                commit('setSnack', snackDetails);
                console.log(error);
            }).then(dt => {
            if( dt.success === true ) {
                var pricelistDetails = {token: dataToken, locked_status: '1', pricelist_id: dt.pricelist_id, locked_by_id: objAuth.id};
                Vue.http.post(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/lock_pricelist', pricelistDetails, rootState.headerDetails)
                    .then(response => {
                        return response.json();
                    }, error => {
                        var snackDetails = {color: 'error', message: 'An error has occured while trying to add the price list', display: true};
                        commit('setSnack', snackDetails);
                        console.log(error);
                    }).then(da => {
                    if( da.success === true ) {
                        var items = [];
                        for (var k in state.priceTableAllSelected) {
                            for (var m in state.priceTableAll) {
                                if (state.priceTableAllSelected[k].pli_id == state.priceTableAll[m].pli_id) {
                                    state.priceTableAll[m] = state.priceTableAllSelected[k];
                                }
                            }
                        }
                        for (var k in state.priceTableAll) {
                            if (parseFloat(state.priceTableAll[k].pli_new_price).toFixed(2) != parseFloat(state.priceTableAll[k].pli_price).toFixed(2)) {
                                var item = {
                                    code: state.priceTableAll[k].pli_code,
                                    description: state.priceTableAll[k].pli_description,
                                    price: state.priceTableAll[k].pli_new_price,
                                    uom: state.priceTableAll[k].pli_uom,
                                    pricing_table: state.priceTableAll[k].pli_pricing_table,
                                    modified_by: objAuth.id,
                                    list_id: dt.pricelist_id
                                }
                            }
                            items.push(item);
                        }
                        var itemDetails = { token: dataToken, items: items };
                        Vue.http.post(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelist_items', itemDetails, rootState.headerDetails)
                            .then(response => {
                                return response.json();
                            }, error => {
                                var snackDetails = {color: 'error', message: 'An error has occured while trying to add the price list', display: true};
                                commit('setSnack', snackDetails);
                                console.log(error);
                            }).then(d => {
                            var snackDetails = {color: 'success', message: 'The pricelist has been added successfully', display: true};
                            commit('setSnack', snackDetails);
                            commit('hideModal');
                            commit('setRunAdd', false);
                            commit('fncEmptyPricelists');
                            dispatch({
                                type: 'fncPopulatePricingTable',
                                refresh: true
                            })
                            dispatch({
                                type: 'fncPopulatePricelistList',
                                refresh: true
                            })
                        });
                    } else {
                        var snackDetails = {color: 'error', message: 'An error has occured while trying to add the price list', display: true};
                        commit('setSnack', snackDetails);
                    }
                });
            } else {
                var snackDetails = {color: 'error', message: 'An error has occured while trying to add the pricelist', display: true};
                commit('setSnack', snackDetails);
            }
        });
    });
}

export const fncLockPricelist = ({ commit, dispatch, state, rootState }, payload) => {
    commit('fncEmptyPricelistEditDetails');
    Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
        .then(response => {
            return response.json();
        }, error => {
            var snackDetails = {color: 'error', message: 'An error has occured while trying to edit the pricelist', display: true};
            commit('setSnack', snackDetails);
            console.log(error);
        }).then(data => {
        var itemDetails = { token: data.token, list_id: payload.obj.pl_id };
        /*commit({
            type: 'fncSetPricelistEditDetails',
            objPlist: payload.obj,
            objPlistItems: state.priceTableAll
        })*/
        Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + 'api/v1/pricelist_items', { params: itemDetails }, rootState.headerDetails)
            .then(response => {
                return response.json();
            }, error => {
                var snackDetails = { color: 'error', message: 'An error has occured while trying to edit the price list', display: true };
                commit('setSnack', snackDetails);
                console.log(error);
            }).then(dt => {
            setTimeout(function () {
                commit({
                    type: 'fncSetPricelistEditDetails',
                    objPlist: payload.obj,
                    objPlistItems: dt
                })
            }, 500)
        });
        /*Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', {params: pricelistDetails}, rootState.headerDetails)
            .then(response => {
                return response.json();
            }, error => {
                var snackDetails = {color: 'error', message: 'An error has occured while trying to edit the price list', display: true};
                commit('setSnack', snackDetails);
                console.log(error);
            }).then(dt => {
                console.log( dt );
                var priceList = dt;
                var itemDetails = {token: data.token, list_id: payload.obj.pl_id};
                Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelist_items', {params: itemDetails}, rootState.headerDetails)
                .then(response => {
                    return response.json();
                }, error => {
                    var snackDetails = {color: 'error', message: 'An error has occured while trying to edit the price list', display: true};
                    commit('setSnack', snackDetails);
                    console.log(error);
                }).then(d => {
                    commit({
                        type: 'fncSetPricelistEditDetails',
                        objPlist: payload.obj,
                        objPlistItems: d
                    })
                });

            });	*/


    });
}

export const fncEditPlist = ({commit, dispatch, state, rootState}) => {
    commit('setRunAdd', true);

    var csvItems = [];
    for( var s in state.priceTableAllSelected ) {
      csvItems[state.priceTableAllSelected[s].pli_code] = state.priceTableAllSelected[s];
      csvItems[state.priceTableAllSelected[s].pli_code].result = 'Price Match';
    }

    var objAuth = JSON.parse(rootState.objAuthorize);
    Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
        .then(response => {
            return response.json();
        }, error => {
            var snackDetails = {color: 'error', message: 'An error has occured while trying to update the pricelist 999', display: true};
            commit('setSnack', snackDetails);
            console.log(error);
        }).then(data => {

        var lockDetails = {
            token: data.token,
            locked_status: 1,
            pricelist_id: state.pricelistEdit.pl_id,
            locked_by_id: objAuth.id
        }

        Vue.http.post(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/lock_pricelist', lockDetails, rootState.headerDetails)
            .then(response => {
                return response.json();
            }, error => {
                var snackDetails = { color: 'error', message: 'An error has occured while trying to update the pricelist 1', display: true };
                commit('setSnack', snackDetails);
                console.log(error);
            }).then(d => {

            var dataToken = data.token;
            var tokenDetails = {token: dataToken, manufacturer_id: objAuth.manufacturer, 'default': 1};
            var plistDetails = {
                token: data.token,
                name: state.pricelistEdit.pl_name,
                description: state.pricelistEdit.pl_description,
                default: state.pricelistEdit.pl_is_default,
                cost: state.pricelistEdit.pl_is_cost,
                active: state.pricelistEdit.pl_active,
                manufacturer_id: objAuth.manufacturer,
                modified_by: objAuth.id,
                tax_label: state.pricelistEdit.pl_tax_label,
                tax_percentage: state.pricelistEdit.pl_tax_percentage,
                currency_sym: state.pricelistEdit.pl_currency_sym,
                currency_code: state.pricelistEdit.pl_currency_code,
                pricelist_id: state.pricelistEdit.pl_id
            }
            Vue.http.post(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', plistDetails, rootState.headerDetails)
                .then(response => {
                    return response.json();
                }, error => {
                    var snackDetails = {color: 'error', message: 'An error has occured while trying to update the pricelist 0', display: true};
                    commit('setSnack', snackDetails);
                    console.log(error);
                }).then(dt => {

                    var itemDetails = { token: data.token, list_id: state.pricelistEdit.pl_id, };
                    Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + 'api/v1/pricelist_items', { params: itemDetails }, rootState.headerDetails)
                        .then(response => {
                            return response.json();
                        }, error => {
                            var snackDetails = { color: 'error', message: 'An error has occured while trying to edit the price list', display: true };
                            commit('setSnack', snackDetails);
                            console.log(error);
                        }).then(pl => {

                            var newList = [];

                            for( var i in pl ) {
                                newList[pl[i]['pli_code']+' '+pl[i]['pli_pricing_table']] = pl[i].pli_id;
                            }

                            for (var k in state.priceTableAllSelected) {
                                for (var m in state.priceTableAll) {
                                    if (state.priceTableAllSelected[k].pli_id == state.priceTableAll[m].pli_id) {
                                        state.priceTableAll[m] = state.priceTableAllSelected[k];
                                    }
                                }
                            }

                            var items = [];
                            for (var k in state.priceTableAll) {
                                if (parseFloat(state.priceTableAll[k].pli_new_price).toFixed(2) != parseFloat(state.priceTableAll[k].pli_price).toFixed(2)) {
                                    var plist_item_id = state.priceTableAll[k].pli_id;
                                    if( newList[state.priceTableAll[k].pli_code+' ' + state.priceTableAll[k].pli_pricing_table] != null ) {
                                        plist_item_id = newList[state.priceTableAll[k].pli_code+' ' + state.priceTableAll[k].pli_pricing_table];
                                    }
                                    var item = {
                                        code: state.priceTableAll[k].pli_code,
                                        description: state.priceTableAll[k].pli_description,
                                        price: state.priceTableAll[k].pli_new_price,
                                        uom: state.priceTableAll[k].pli_uom,
                                        pricing_table: state.priceTableAll[k].pli_pricing_table,
                                        modified_by: objAuth.id,
                                        pricelist_item_id: plist_item_id,
                                        excel_price: state.priceTableAll[k].pli_price,
                                        status: 'Updated',
                                    }
                                    items.push(item);
                                }
                            }

                            var loopCount = Math.ceil( items.length / 100 );
                            var loopCountCompleted = 0;

                            //var itemDetails = { token: dataToken, items: items };
                            if( items.length > 0 ) {

                                var spineAdded = [];
                                var spineRecords = [];

                                for (i=1; i<=loopCount; i++) {

                                    loopCountCompleted = i;

                                    var intStart = ( i * 100 ) - 100;
                                    var intEnd = ( i * 100 ) - 1;
                                    var newObj = [];
                                    var timeSplit = ( i - 1 ) * 2000;

                                    if( loopCountCompleted == loopCount ) {

                                        var counter = 0;

                                        for( var item in items ) {

                                            if( intStart <= counter && intEnd >= counter  ) {
                                                newObj.push( items[item] );
                                            }
                                            counter++;

                                        }

                                        var itemDetails = { token: dataToken, items: newObj };

                                        Vue.http.post(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelist_items', itemDetails, rootState.headerDetails)
                                            .then(response => {
                                                return response.json();
                                            }, error => {
                                                var snackDetails = { color: 'error', message: 'An error has occured while trying to update the price list 5', display: true };
                                                commit('setSnack', snackDetails);
                                                console.log(error);
                                            }).then(dd => {

                                                for( var r in dd ) {
                                                    /*if( !dd[r].response.success ) {
                                                        spineRecords.push( dd[r].item.status = 'Update Failed' )
                                                    }*/

                                                    /*console.log( csvItems[dd[r].item.code] )*/

                                                  csvItems[dd[r].item.code].result = 'False';

                                                  if( csvItems[dd[r].item.code].pli_price == csvItems[dd[r].item.code].pli_new_price ) {
                                                    csvItems[dd[r].item.code].result = 'Price Match';
                                                  } else if( dd[r].response.success == true || dd[r].response.success == 'true' ) {
                                                    csvItems[dd[r].item.code].result = 'Updated';
                                                  }

                                                    spineRecords.push( dd[r].item )
                                                    spineAdded.push( dd[r].item.code );
                                                }

                                                var timeout = ( i * 2500 );

                                                setTimeout(function(){

                                                   // console.log( csvItems );

                                                    var unlockDetails = {
                                                        token: data.token,
                                                        locked_status: 0,
                                                        pricelist_id: state.pricelistEdit.pl_id,
                                                        locked_by_id: objAuth.id
                                                    }
                                                    Vue.http.post(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/lock_pricelist', unlockDetails, rootState.headerDetails)
                                                        .then(response => {
                                                            return response.json();
                                                        }, error => {
                                                            var snackDetails = { color: 'error', message: 'An error has occured while trying to update the pricelist 10', display: true };
                                                            commit('setSnack', snackDetails);
                                                            console.log(error);
                                                        }).then(l => {
                                                        var snackDetails = { color: 'success', message: 'The pricelist has been updated successfully', display: true };
                                                        commit('setSnack', snackDetails);
                                                        commit('hideModal');
                                                        commit('setRunAdd', true);
                                                        commit('setRunAdd', false);
                                                        commit('fncEmptyPricelists');
                                                        dispatch({
                                                            type: 'fncPopulatePricelistList',
                                                            refresh: true
                                                        })
                                                        dispatch({
                                                            type: 'fncPopulatePricingTable',
                                                            refresh: true
                                                        })

                                                        if( state.nonImport.length > 0 ) {
                                                            for( var u in state.nonImport ) {
                                                                if( spineAdded.indexOf( state.nonImport[u].code ) == -1 ) {
                                                                    var newItem = {
                                                                        code: state.nonImport[u].code,
                                                                        excel_price: 'N/A',
                                                                        pricing_table: state.priceTableAllSelected[0].pli_pricing_table,
                                                                        price: state.nonImport[u].price,
                                                                        status: 'Price Match'
                                                                    };
                                                                    spineRecords.push(newItem);
                                                                    spineAdded.push( state.nonImport[u].code );
                                                                }
                                                            }
                                                        }

                                                        if( state.undefinedImport.length > 0 ) {
                                                            for( var u in state.undefinedImport ) {
                                                                if( spineAdded.indexOf( state.undefinedImport[u].code ) == -1 ) {
                                                                    var newItem = {
                                                                        code: state.undefinedImport[u].code,
                                                                        excel_price: 'N/A',
                                                                        pricing_table: state.priceTableAllSelected[0].pli_pricing_table,
                                                                        price: state.undefinedImport[u].price,
                                                                        status: 'False'
                                                                    };
                                                                    spineRecords.push(newItem);
                                                                }
                                                            }
                                                        }

                                                        // ok now we need to send the stuffs t the excel doccie
                                                      var csvMini = [];
                                                      for( var c in csvItems ){
                                                        csvMini.push({code: csvItems[c].pli_code, excel_price: csvItems[c].pli_price, pricing_table: csvItems[c].pli_pricing_table, price: csvItems[c].pli_new_price, status: csvItems[c].result})
                                                      }
                                                        var formData = {data: JSON.stringify(csvMini)};
                                                        // var formData = {data: JSON.stringify(spineRecords)};
                                                        Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=pricetable_report', formData, rootState.headerDetails)
                                                            .then(response => {
                                                                return response.json();
                                                            }, error => {
                                                                var snackDetails = {color: 'error', message: 'An error occured while trying to remove the privilege', display: true};
                                                                commit('setSnack', snackDetails);
                                                            }).then(data => {
                                                            if( data.success == true ) {
                                                                var reportDownload = document.createElement('a');
                                                                reportDownload.setAttribute('href', data.file);
                                                                reportDownload.setAttribute('download', 'spine_report.xlsx');
                                                                reportDownload.click();
                                                            }

                                                        });

                                                    });
                                                }, timeout)

                                        });

                                    } else {

                                        var counter = 0;

                                        for( var item in items ) {
                                            if( intStart <= counter && intEnd >= counter  ) {
                                                newObj.push( items[item] );
                                            }
                                            counter++;
                                        }

                                        var itemDetails = { token: dataToken, items: newObj };

                                        Vue.http.post(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelist_items', itemDetails, rootState.headerDetails)
                                            .then(response => {
                                                return response.json();
                                            }, error => {
                                                var snackDetails = { color: 'error', message: 'An error has occured while trying to update the price list 5', display: true };
                                                commit('setSnack', snackDetails);
                                                console.log(error);
                                            }).then(dd => {

                                                for( var r in dd ) {
                                                    /*if( !dd[r].response.success ) {
                                                        spineRecords.push( dd[r].item.status = 'Update Failed' )
                                                    }*/

                                                  csvItems[dd[r].item.code].result = 'False';

                                                  if( csvItems[dd[r].item.code].pli_price == csvItems[dd[r].item.code].pli_new_price ) {
                                                    csvItems[dd[r].item.code].result = 'Price Match';
                                                  } else if( dd[r].response.success == true || dd[r].response.success == 'true' ) {
                                                    csvItems[dd[r].item.code].result = 'Updated';
                                                  }

                                                    spineRecords.push( dd[r].item )
                                                    spineAdded.push( dd[r].item.code );
                                                }
                                        });

                                    }

                                }

                            } else {

                                var spineAdded = [];

                                var unlockDetails = {
                                    token: data.token,
                                    locked_status: 0,
                                    pricelist_id: state.pricelistEdit.pl_id,
                                    locked_by_id: objAuth.id
                                }
                                Vue.http.post(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/lock_pricelist', unlockDetails, rootState.headerDetails)
                                    .then(response => {
                                        return response.json();
                                    }, error => {
                                        var snackDetails = { color: 'error', message: 'An error has occured while trying to update the pricelist 10', display: true };
                                        commit('setSnack', snackDetails);
                                        console.log(error);
                                    }).then(l => {
                                    var snackDetails = { color: 'success', message: 'The pricelist has been updated successfully', display: true };
                                    commit('setSnack', snackDetails);
                                    commit('hideModal');
                                    commit('setRunAdd', true);
                                    commit('setRunAdd', false);
                                    commit('fncEmptyPricelists');
                                    dispatch({
                                        type: 'fncPopulatePricelistList',
                                        refresh: true
                                    })
                                    dispatch({
                                        type: 'fncPopulatePricingTable',
                                        refresh: true
                                    })

                                    var items = [];

                                    if( state.nonImport.length > 0 ) {
                                        for( var u in state.nonImport ) {
                                            if( spineAdded.indexOf( state.nonImport[u].code ) == -1 ) {
                                                var newItem = {
                                                    code: state.nonImport[u].code,
                                                    excel_price: 'N/A',
                                                    pricing_table: state.priceTableAllSelected[0].pli_pricing_table,
                                                    price: state.nonImport[u].price,
                                                    status: 'Price Match'
                                                };
                                                items.push(newItem);
                                                spineAdded.push( state.nonImport[u].code );
                                            }
                                        }
                                    }

                                    if( state.undefinedImport.length > 0 ) {
                                        for( var u in state.undefinedImport ) {
                                            if( spineAdded.indexOf( state.undefinedImport[u].code ) == -1 ) {
                                                var newItem = {
                                                    code: state.undefinedImport[u].code,
                                                    price: state.undefinedImport[u].price,
                                                    pricing_table: state.priceTableAllSelected[0].pli_pricing_table,
                                                    excel_price: 'N/A',
                                                    status: 'False'
                                                }
                                                items.push(newItem);
                                            }
                                        }
                                    }

                                    // ok now we need to send the stuffs t the excel doccie
                                  var csvMini = [];
                                  for( var c in csvItems ){
                                    csvMini.push({code: csvItems[c].pli_code, excel_price: csvItems[c].pli_price, pricing_table: csvItems[c].pli_pricing_table, price: csvItems[c].pli_new_price, status: csvItems[c].result})
                                  }
                                    var formData = {data: JSON.stringify(csvMini)};
                                   // var formData = {data: JSON.stringify(items)};
                                    Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=pricetable_report', formData, rootState.headerDetails)
                                        .then(response => {
                                            return response.json();
                                        }, error => {
                                            var snackDetails = {color: 'error', message: 'An error occured while trying to remove the privilege', display: true};
                                            commit('setSnack', snackDetails);
                                        }).then(data => {
                                        if( data.success == true ) {
                                            var reportDownload = document.createElement('a');
                                            reportDownload.setAttribute('href', data.file);
                                            reportDownload.setAttribute('download', 'spine_report.xlsx');
                                            reportDownload.click();
                                        }

                                    });

                                });

                            }

                    });


                    /*for (var k in state.priceTableAllSelected) {
                        for (var m in state.priceTableAll) {
                            if (state.priceTableAllSelected[k].pli_id == state.priceTableAll[m].pli_id) {
                                state.priceTableAll[m] = state.priceTableAllSelected[k];
                            }
                        }
                    }
                    var items = [];
                    for (var k in state.priceTableAll) {
                        if (parseFloat(state.priceTableAll[k].pli_new_price).toFixed(2) != parseFloat(state.priceTableAll[k].pli_price).toFixed(2)) {
                            var item = {
                                code: state.priceTableAll[k].pli_code,
                                description: state.priceTableAll[k].pli_description,
                                price: state.priceTableAll[k].pli_new_price,
                                uom: state.priceTableAll[k].pli_uom,
                                pricing_table: state.priceTableAll[k].pli_pricing_table,
                                modified_by: objAuth.id,
                                pricelist_item_id: state.priceTableAll[k].pli_id
                            }
                            items.push(item);
                        }
                    }
                    var itemDetails = { token: dataToken, items: items };
                    if( items.length > 0 ) {
                        Vue.http.post(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelist_items', itemDetails, rootState.headerDetails)
                            .then(response => {
                                return response.json();
                            }, error => {
                                var snackDetails = { color: 'error', message: 'An error has occured while trying to update the price list 5', display: true };
                                commit('setSnack', snackDetails);
                                console.log(error);
                            }).then(dd => {
                            console.log( dd );
                            var unlockDetails = {
                                token: data.token,
                                locked_status: 0,
                                pricelist_id: state.pricelistEdit.pl_id,
                                locked_by_id: objAuth.id
                            }
                            Vue.http.post(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/lock_pricelist', unlockDetails, rootState.headerDetails)
                                .then(response => {
                                    return response.json();
                                }, error => {
                                    var snackDetails = { color: 'error', message: 'An error has occured while trying to update the pricelist 10', display: true };
                                    commit('setSnack', snackDetails);
                                    console.log(error);
                                }).then(l => {
                                var snackDetails = { color: 'success', message: 'The pricelist has been updated successfully', display: true };
                                commit('setSnack', snackDetails);
                                commit('hideModal');
                                commit('setRunAdd', true);
                                commit('setRunAdd', false);
                                commit('fncEmptyPricelists');
                                dispatch({
                                    type: 'fncPopulatePricelistList',
                                    refresh: true
                                })
                                dispatch({
                                    type: 'fncPopulatePricingTable',
                                    refresh: true
                                })
                            });
                        });
                    } else {

                        var unlockDetails = {
                            token: data.token,
                            locked_status: 0,
                            pricelist_id: state.pricelistEdit.pl_id,
                            locked_by_id: objAuth.id
                        }
                        Vue.http.post(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/lock_pricelist', unlockDetails, rootState.headerDetails)
                            .then(response => {
                                return response.json();
                            }, error => {
                                var snackDetails = { color: 'error', message: 'An error has occured while trying to update the pricelist 10', display: true };
                                commit('setSnack', snackDetails);
                                console.log(error);
                            }).then(l => {
                            var snackDetails = { color: 'success', message: 'The pricelist has been updated successfully', display: true };
                            commit('setSnack', snackDetails);
                            commit('hideModal');
                            commit('setRunAdd', true);
                            commit('setRunAdd', false);
                            commit('fncEmptyPricelists');
                            dispatch({
                                type: 'fncPopulatePricelistList',
                                refresh: true
                            })
                            dispatch({
                                type: 'fncPopulatePricingTable',
                                refresh: true
                            })
                        });

                    }*/

            });

        });

    });

}

export const fncClonePlist = ({commit, dispatch, state, rootState}, payload) => {
    commit('setRunAdd', true);
    var objAuth = JSON.parse(rootState.objAuthorize);
    Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
        .then(response => {
            return response.json();
        }, error => {
            var snackDetails = {color: 'error', message: 'An error has occured while trying to clone the pricelist', display: true};
            commit('setSnack', snackDetails);
            console.log(error);
        }).then(data => {
        var cloneDetails = { token: data.token, new_name: payload.pricelistName, pricelist_id: payload.pricelistId, modify_user_id: objAuth.id};
        Vue.http.post(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/clone_pricelist', cloneDetails, rootState.headerDetails)
            .then(response => {
                return response.json();
            }, error => {
                var snackDetails = {color: 'error', message: 'An error has occured while trying to clone the price list', display: true};
                commit('setSnack', snackDetails);
                console.log(error);
            }).then(dt => {

                // link user to newly cloned pricelist
                var newId = dt.pricelist_id;
                var oldId = payload.pricelistId;

                Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=link_users_to_cloned_pricelist', { newId: newId, oldId: oldId }, rootState.headerDetails)
                  .then(response => {
                    return response.json();
                  }, error => {
                    var snackDetails = { color: 'error', message: 'An error has occured while trying to update the pricelist 10', display: true };
                    commit('setSnack', snackDetails);
                    console.log(error);
                  }).then(l => {

                  dispatch({
                    type: 'fncPopulatePricelistList',
                    refresh: true
                  });
                  var snackDetails = {color: 'success', message: 'The pricelist has been cloned successfully', display: true};
                  commit('setSnack', snackDetails);
                  commit('hideModal');
                  commit('setRunAdd', false);

                });

            /*dispatch({
                type: 'fncPopulatePricelistList',
                refresh: true
            });
            var snackDetails = {color: 'success', message: 'The pricelist has been cloned successfully', display: true};
            commit('setSnack', snackDetails);
            commit('hideModal');
            commit('setRunAdd', false);*/
        });
    });
}

export const fncAddNewPlist = ({ commit, dispatch, state, rootState }, payload) => {
    var objAuth = JSON.parse(rootState.objAuthorize);
    Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
        .then(response => {
            return response.json();
        }, error => {
            console.log(error);
        }).then(data => {
        var objAuthorize = JSON.parse(rootState.objAuthorize);
        var pricelistDetails = { token: data.token, manufacturer_id: objAuthorize.manufacturer, active: 1, is_library_pricelist: 1 };
        Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: pricelistDetails }, rootState.headerDetails)
            .then(response => {
                return response.json();
            }, error => {
                console.log(error);
            }).then(dt => {
            var cloneDetails = { token: data.token, new_name: payload.pricelistName, pricelist_id: dt[0].pl_id, modify_user_id: objAuth.id };
            Vue.http.post(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/clone_pricelist', cloneDetails, rootState.headerDetails)
                .then(response => {
                    return response.json();
                }, error => {
                    var snackDetails = { color: 'error', message: 'An error has occured while trying to clone the price list', display: true };
                    commit('setSnack', snackDetails);
                    console.log(error);
                }).then(dt => {
                dispatch({
                    type: 'fncPopulatePricelistList',
                    refresh: true
                });
                var snackDetails = { color: 'success', message: 'The pricelist has been created successfully', display: true };
                commit('setSnack', snackDetails);
                commit('setRunAdd', false);
                dispatch({
                    type: 'fncPopulatePricelistList',
                    refresh: true
                })
                dispatch({
                    type: 'fncPopulatePricingTable',
                    refresh: true
                })
                commit('hideModal');
            });
        });
    });
}

export const fncDisplayLibraryUpdate = ({ commit, dispatch, state, rootState }, payload) => {

    var objAuth = JSON.parse(rootState.objAuthorize);

    Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
        .then(response => {
            return response.json();
        }, error => {
            console.log(error);
        }).then(data => {

            var pricelistDetails = { token: data.token, pricelist_id: payload.pl_id, modify_user_id: objAuth.id, apply_changes: 0 };

            Vue.http.post(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/refresh_from_library_pricelist', pricelistDetails, rootState.headerDetails)
                .then(response => {
                    return response.json();
                }, error => {
                    console.log(error);
                }).then(dt => {

                    commit( 'fncIsLibraryUpdate', dt );

            });
    });

}

export const fncGetLibraryUpdate = ({ commit, dispatch, state, rootState }, payload) => {

    var objAuth = JSON.parse(rootState.objAuthorize);

    Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
        .then(response => {
            return response.json();
        }, error => {
            console.log(error);
        }).then(data => {

        var pricelistDetails = { token: data.token, pricelist_id: payload.pricelist.pl_id, modify_user_id: objAuth.id, apply_changes: payload.decision };

        Vue.http.post(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/refresh_from_library_pricelist', pricelistDetails, rootState.headerDetails)
            .then(response => {
                return response.json();
            }, error => {
                console.log(error);
            }).then(dt => {

                commit( 'fncIsLibraryUpdateFalse', false );
                commit( 'setPricelistEdit', '');
                commit( 'setEmptyPriceTableAllSelected', []);
                commit( 'setLibraryLoading', false);

                if( payload.decision == true ) {
                    var snackDetails = { color: 'success', message: 'The library update was accepted successfully', display: true };
                    commit('setSnack', snackDetails);
                } else {
                    var snackDetails = { color: 'success', message: 'The library update was declined successfully', display: true };
                    commit('setSnack', snackDetails);
                }

                dispatch({
                    type: 'fncLockPricelist',
                    obj: payload.pricelist
                })

        });
    });

}
